module.exports = __webpack_public_path__ + "media/images/countryrect/bw-ef2e0f1d675e7438fdb2e297b5b27e18.svg";